'use client'

import { Cell, Icon, Text, Spacer, Divider } from '@vinted/web-ui'
import { Fire24 } from '@vinted/monochrome-icons'
import { useInView } from 'react-intersection-observer'

import {
  ItemPageHighDemandSignalInfoPluginModel,
  itemPageViewEvent,
} from '@marketplace-web/item-page/item-page-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

const ItemPageHighDemandSignalInfoPlugin = ({
  title,
  itemId,
  pluginName,
}: ItemPageHighDemandSignalInfoPluginModel & { pluginName: string }) => {
  const { track } = useTracking()

  const { ref } = useInView({
    onChange: inView => {
      if (!inView) return
      track(
        itemPageViewEvent({
          item_id: itemId.toString(),
          target: 'high_demand',
        }),
      )
    },
    triggerOnce: true,
  })

  return (
    <div ref={ref}>
      <Spacer size="large" />
      <Divider orientation="horizontal" />
      <Spacer size="large" />
      <Cell
        prefix={<Icon name={Fire24} color="warning-default" />}
        title={<Text as="span" text={title} html type="subtitle" theme="amplified" />}
        styling="tight"
        testId={pluginName}
      />
      <Spacer size="regular" />
    </div>
  )
}

export default ItemPageHighDemandSignalInfoPlugin
